import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { COURSE_TYPE_QUERY } from '../graphql/queries'
import { FETCH_COURSE_TYPE } from '../redux/action-types'
import { cleanupFetchCourseType } from '../redux/actions'

const useCourseTypeQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchCourseType)

  const { isLoading, error, data } = useSelector(
    store => store.courseTypes.courseType,
  )

  const refetch = useCallback(
    id =>
      apolloService.query(
        COURSE_TYPE_QUERY,
        { id },
        dispatch,
        FETCH_COURSE_TYPE,
      ),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading, error, data }
}

export default useCourseTypeQuery
